<h1 mat-dialog-title class="dialog-title" fxLayout="row">
	Print Quote Report
</h1>

<div mat-dialog-content [formGroup]="quoteReportForm">
	<div class="mb-2">
		<mat-checkbox formControlName="addToDocuments"
			>Add to documents</mat-checkbox
		>
	</div>
</div>
<div mat-dialog-actions fxLayoutAlign="end">
	<button mat-button color="primary" (click)="close()">
		Cancel
	</button>
	<button
		mat-button
		color="primary"
		(click)="generateQuoteReport()"
		[disabled]="!quoteReportForm.valid"
	>
		<div fxLayout="row">
			Download
		</div>
	</button>
</div>
